import { render, staticRenderFns } from "./m-snackbar.vue?vue&type=template&id=5ac819d6&scoped=true"
import script from "./m-snackbar.vue?vue&type=script&lang=js"
export * from "./m-snackbar.vue?vue&type=script&lang=js"
import style0 from "./m-snackbar.vue?vue&type=style&index=0&id=5ac819d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac819d6",
  null
  
)

export default component.exports